import { SectionTitle } from "../_shared/section-title";
import { PageShell, Stack } from "../_shared/page-shell";
import { Card } from "../_shared/card";
import { ProgressRing } from "../_shared/progress-ring";
import { ProgressBar } from "../_shared/progress-bar";
import { alignerProgress, children } from "../_data/mock";

const accent = {
  orange: "text-[var(--child-1-primary)]",
  blue: "text-[var(--child-2-primary)]",
} as const;

export function AlignersPage() {
  return (
    <>
      <SectionTitle title="Aligneurs" />
      <PageShell>
        <Stack>
          {alignerProgress.map((a) => {
            const child = children.find((c) => c.id === a.childId);
            if (!child) return null;
            const stepProgress = a.currentStep / a.totalSteps;
            const dayProgress = 1 - a.daysLeft / a.totalDays;
            return (
              <Card key={a.childId} title={child.firstName}>
                <div className="flex items-center gap-4">
                  <ProgressRing
                    progress={dayProgress}
                    tone={child.color}
                    label={`${a.daysLeft}j`}
                    sublabel="restants"
                  />
                  <div className="min-w-0 flex-1">
                    <p
                      className={`text-[13px] font-semibold ${accent[child.color]}`}
                    >
                      Étape {a.currentStep} sur {a.totalSteps}
                    </p>
                    <p className="text-[12px] text-[var(--text-2)]">
                      Changement prévu dans {a.daysLeft} jours
                    </p>
                    <div className="mt-2">
                      <ProgressBar progress={stepProgress} tone={child.color} />
                    </div>
                  </div>
                </div>
              </Card>
            );
          })}
        </Stack>
      </PageShell>
    </>
  );
}
